export default __webpack_public_path__ + "static/media/greenMeds.0c20fe76.svg";